
<div class="card-block">
  <div class="row m-2">
    <div class="col p-0">
      <h5 class="float-left">Purchase Orders for Customer Invoicing</h5>
    </div>
  </div>
  <div class="row m-2">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row m-2" *ngIf="displaySavingMessage">
    <div class="col alert alert-info"><span>Saving...</span></div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-group form-check d-inline-block ml-2" *ngIf="showOrdersType">
        <input class="form-check-input" type="radio" id="customerPORadio" [(ngModel)]="purchaseOrdersCategory" name="radioSelectPendingOrSigned" [value]="'customerPO'" [disabled]="disableRadioButtons">
        <label class="form-check-label m-0" for="customerPORadio">Customer PO</label>
      </div>
      <div class="form-group form-check m-0 d-inline-block ml-3" *ngIf="showOrdersType">
        <input class="form-check-input" type="radio" id="pendingPORadio" [(ngModel)]="purchaseOrdersCategory" name="radioSelectPendingOrSigned" [value]="'pendingPO'" [disabled]="disableRadioButtons">
        <label class="form-check-label m-0" for="pendingPORadio">Pending PO</label>
      </div>
      <div class="form-group form-check m-0 d-inline-block ml-3" *ngIf="_purchaseOrdersType === 'NONE'">
        <input class="form-check-input" type="radio" id="perSignedSOWRadio" [(ngModel)]="purchaseOrdersCategory" name="radioSelectPendingOrSigned" [value]="'perSignedSow'" [disabled]="disableRadioButtons" *ngIf="showOrdersType">
        <label class="form-check-label m-0" for="perSignedSOWRadio" *ngIf="showOrdersType">Per Signed SOW</label>
      </div>
      <div class="form-group form-check m-0 d-inline-block ml-5" *ngIf="por18_2_flag &amp;&amp; allowedTargetSystem &amp;&amp; !isMAActive">
        <label class="form-check-label m-0">Monthly PO</label>
        <input class="form-check-input ml-2" type="radio" id="monthlyPORadioYes" name="radioSelectMonthlyPO" value="true" [checked]="isMonthlyPOSelected === true" (change)="publishChange($event.target.value)">
        <label class="form-check-label ml-4" for="monthlyPORadioYes">Yes</label>
      </div>
      <div class="form-group form-check d-inline-block ml-2" *ngIf="por18_2_flag &amp;&amp; allowedTargetSystem &amp;&amp; !isMAActive">
        <input class="form-check-input" type="radio" id="monthlyPORadioNo" name="radioSelectMonthlyPO" value="false" [checked]="isMonthlyPOSelected === false" (change)="publishChange($event.target.value)">
        <label class="form-check-label m-0" for="monthlyPORadioNo">No</label>
      </div>
    </div>
  </div>
  <div class="row" *ngFor="let purchaseOrder of purchaseOrdersToLoad; let i = index;">
    <div class="col px-4">
      <purchase-order-grid [purchaseOrder]="purchaseOrder" [purchaseOrderIndex]="i" [purchaseOrderCategory]="purchaseOrdersCategory" [firstTimeVisit]="firstTimeVisit" [showSelectPOLink]="showSelectPOLink" [purchaseOrdersITSM]="purchaseOrdersITSM" [readOnlyInputs]="gridsReadOnlyInputs" [enableDartOffers]="enableDartOffersOnGrid" (newPoSelectedEvent)="newPoSelected($event, i)" [selectedPurchaseOrders]="purchaseOrdersToLoad" [purchaseOrdersType]="_purchaseOrdersType" [projectId]="_projectId" (removedPOEvent)="removedPO($event)" [isDisabled]="disableUI()"></purchase-order-grid>
    </div>
  </div>
  <div class="row" *ngIf="_purchaseOrdersType !== 'NONE'">
    <div class="col px-4 mb-2">
      <button class="btn btn-outline-primary float-right ml-2" *ngIf="!firstTimeVisit &amp;&amp; _purchaseOrdersType === 'OFFER'" type="button" (click)="savePurchaseOrders()" [disabled]="disableSavingButton">Save Changes</button>
      <button class="btn btn-outline-primary float-right" type="button" (click)="addNewPO()" [disabled]="disableAddNewPOButton">Add New PO</button>
    </div>
  </div>
</div>